import { Location } from "history";
import { useSelector } from "react-redux";

import { Link } from "@seneca/senekit";

import { getRegion } from "seneca-common/features/user/state";

import SignUpFormBottomLink from "features/sign-up/components/SignUpFormBottomLink";

type ResetPasswordBottomLinkProps = {
  signedIn: boolean;
  signInLink: Location | string;
};

export default function ResetPasswordBottomLink({
  signedIn,
  signInLink
}: ResetPasswordBottomLinkProps) {
  const changePasswordHelpLink = useChangePasswordHelpLink();

  if (signedIn) {
    return (
      <Link size="small" to={changePasswordHelpLink}>
        Trouble setting a new password?
      </Link>
    );
  }

  return (
    <SignUpFormBottomLink
      bottomText="Know your password?"
      bottomLink={signInLink}
      bottomLinkText="Log in"
    />
  );
}

function useChangePasswordHelpLink() {
  const region = useSelector(getRegion);

  switch (region) {
    case "AT":
    case "DE":
      return "https://docs.google.com/forms/d/e/1FAIpQLSel8UEbPkMs7iIDMZkf_bBRW0Gn50Kmq4gI8GYhboZNVYOO4Q/viewform?usp=sf_link";
    default:
      return "https://docs.google.com/forms/d/e/1FAIpQLSeZ9xSV8eQMWgEiBVDjNCLALV6Y4AoBSpMireAx0ag-VM4Ejg/viewform?usp=sf_link";
  }
}
